export class FbMatch {
  public id: number;
  public matchNum: number;
  public date: string;
  public startTime: string;
  public cornerNum: number;
  public matchTypeName: string;
  public matchType: number;
  public matchProgress: number;
  public currentMin: string;
  public homeScore: number;
  public awayScore: number;
  public homeName: string;
  public awayName: string;
  public favorite: boolean;
  public dayOfWeek: number;
  public firstHalfHomeScore: number;
  public firstHalfAwayScore: number;

  constructor(id: number, matchNum: number, date: string, startTime: string, cornerNum: number,
    matchTypeName: string, matchType: number, matchProgress: number, currentMin: string,
    homeScore: number, awayScore: number, homeName: string, awayName: string, favorite: boolean,
    dayOfWeek: number, firstHalfHomeSocre: number, firstHalfAwayScore: number) {
    this.id = id;
    this.matchNum = matchNum;
    this.date = date;
    this.startTime = startTime;
    this.cornerNum = cornerNum;
    this.matchTypeName = matchTypeName;
    this.matchType = matchType;
    this.matchProgress = matchProgress;
    this.currentMin = currentMin;
    this.homeScore = homeScore;
    this.awayScore = awayScore;
    this.homeName = homeName;
    this.awayName = awayName;
    this.favorite = favorite;
    this.dayOfWeek = dayOfWeek;
    this.firstHalfHomeScore = firstHalfHomeSocre;
    this.firstHalfAwayScore = firstHalfAwayScore;
  }

  copy(fbMatch: FbMatch) {
    this.id = fbMatch.id;
    this.matchNum = fbMatch.matchNum;
    this.date = fbMatch.date;
    this.startTime = fbMatch.startTime;
    this.cornerNum = fbMatch.cornerNum;
    this.matchTypeName = fbMatch.matchTypeName;
    this.matchType = fbMatch.matchType;
    this.matchProgress = fbMatch.matchProgress;
    this.currentMin = fbMatch.currentMin;
    this.homeScore = fbMatch.homeScore;
    this.awayScore = fbMatch.awayScore;
    this.homeName = fbMatch.homeName;
    this.awayName = fbMatch.awayName;
    this.favorite = fbMatch.favorite;
    this.dayOfWeek = fbMatch.dayOfWeek;
    this.firstHalfHomeScore = fbMatch.firstHalfHomeScore;
    this.firstHalfAwayScore = fbMatch.firstHalfAwayScore;
  }

  isFinished(): boolean {
    return this.matchProgress == 4 || this.matchProgress == 6;
  }

  isFullTime(): boolean {
    return this.matchProgress == 4;
  }

  isNotStarted(): boolean {
    return this.matchProgress == 0;
  }

  isCurrentlyPlaying(): boolean {
    return this.matchProgress == 1 || this.matchProgress == 2
        || this.matchProgress == 3 || this.matchProgress == 5;
  }

}



// WEBPACK FOOTER //
// ./src/model/FbMatch.ts